import React, { useState, useEffect } from 'react';
import axios from "../common/axios";
import ListItem from "../common/ListItem";

const Notifications = props => {
    const {handleClose, setBadgeCount, fromLogin} = props;
    const [notifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState(10);

    const getNotifications = () => {
        axios.get('/dashboard/updateNotifications.action', {
            display: fromLogin
        })
            .then(response => {
                if(response.data && Array.isArray(response.data)) {
                    setNotifications(response.data);
                } else {
                    setNotifications([]);
                }
            });
    }
    function openNotificationWS (connectionCount) {
        if (connectionCount > 30) {
            return;
        }
        try {
            const webSocketUrl = ((window.location.protocol === 'https:') ? 'wss://' : 'ws://') + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/notificationCheck';
            const socket = new WebSocket(webSocketUrl);
            socket.onmessage = function (event) {
                const data = jQuery.parseJSON(event.data);
                if (data !== null) {
                    setNotifications(notifications => {
                        let newNotifications = [];
                        data.map(newNotification => {
                            if (notifications.find(notification => notification.notificationType === newNotification.notificationType) === undefined) {
                                newNotifications.push(newNotification);
                            } else {
                                notifications.map((notification) => {
                                    if (notification.notificationType === newNotification.notificationType) {
                                        newNotifications.push(newNotification);
                                    } else {
                                        newNotifications.push(notification);
                                    }
                                });
                            }
                        });
                        return newNotifications;
                    });
                }
            }
            socket.onclose = function (event) {
                if (event.code != 1001) {
                    return;
                }
                let reconnectDelay = connectionCount * 50 + 1000;
                if (reconnectDelay > 3000) {
                    reconnectDelay = 3000;
                }
                setTimeout(function () {
                    openNotificationWS(connectionCount + 1);
                }, reconnectDelay);
            }
        } catch (e) {
            console.error('Error connecting to websocket notification', e);
        }
    }
    useEffect(() => {
        getNotifications();
        openNotificationWS();
    }, []);

    useEffect(() => {
        let count = 0;
        notifications.map((notification, index) => {
            if(notification.itemCount > 0) {
                count += 1;
            }
        });
        setNotificationCount(count);
        setBadgeCount(count);
    }, [notifications]);

    return (
        <>
            {notifications.length == 0 && (
                <div>No notifications</div>
            )}
            {notifications.length > 0 && (
                <ul className={'ch-list'}>
                {notifications.map((notification, index) => {
                    const {url, loadFunction} = notification;
                    const handleOnClick = () => {
                        if (handleClose !== undefined && typeof handleClose === 'function') handleClose();
                        if (loadFunction !== undefined && typeof loadFunction === 'string') window[loadFunction]();
                    }
                    return (
                        <ListItem key={index} url={url} onClick={handleOnClick}>
                            <span>{notification.notificationDescription}&nbsp;({notification.itemCount})</span>
                        </ListItem>
                    )
                })}
            </ul>
            )}
        </>
    )
}

export default Notifications;